/**
 * Created by AlexanderC on 2/22/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KinesisDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _UUID = require('./Kinesis/UUID');

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let KinesisDriver = exports.KinesisDriver = function (_AbstractDriver) {
  _inherits(KinesisDriver, _AbstractDriver);

  /**
   * @param   {String}    kinesisEventStream
   * @param   {*} args
   */
  function KinesisDriver(kinesisEventStream) {
    var _ref;

    _classCallCheck(this, KinesisDriver);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = KinesisDriver.__proto__ || Object.getPrototypeOf(KinesisDriver)).call.apply(_ref, [this].concat(args)));

    _this._partitionKey = null;
    _this._kinesisEventStream = _this._normalizeStreamName(kinesisEventStream);
    _this._kinesis = new _awsSdk2.default.Kinesis(_this._serviceOptionsFromStreamArn(kinesisEventStream));
    return _this;
  }

  /**
   * @returns {AWS.Kinesis|*} 
   */


  _createClass(KinesisDriver, [{
    key: '_serviceOptionsFromStreamArn',


    /**
     * @param {String} kinesisEventStream
     *
     * @returns {*}
     *
     * @private
     */
    value: function _serviceOptionsFromStreamArn(kinesisEventStream) {
      const matches = kinesisEventStream.match(/^arn:aws:kinesis:([^:]+):([^:]+):stream\//i);

      if (!matches || matches.length < 3) {
        return {};
      }

      return {
        region: matches[1]
      };
    }

    /**
     * @param {String} kinesisEventStream
     *
     * @returns {String}
     *
     * @private
     */

  }, {
    key: '_normalizeStreamName',
    value: function _normalizeStreamName(kinesisEventStream) {
      return kinesisEventStream.replace(/^.+\/([^\/]+)$/i, '$1');
    }

    /**
     * @param   {String} name
     * @param   {*} data
     * @param   {Object} context
     *
     * @returns {Promise|*}
     *
     * @private
     */

  }, {
    key: '_log',
    value: function _log(name, data, context) {
      return this._push([{ name: name, data: data, context: context }]);
    }

    /**
     * @param   {Array} events
     *
     * @returns {Promise|*}
     *
     * @private
     */

  }, {
    key: '_push',
    value: function _push(events) {
      if (events.length <= 0) {
        return Promise.resolve();
      } else if (events.length > KinesisDriver.MAX_PUT_LENGTH) {
        return Promise.all(this._chunks(events, KinesisDriver.MAX_PUT_LENGTH).map(chunk => this._push(chunk)));
      }

      return new Promise((resolve, reject) => {
        const payload = {
          StreamName: this.kinesisEventStream,
          Records: events.map(event => {
            return {
              Data: JSON.stringify(event),
              PartitionKey: this.partitionKey
            };
          })
        };

        this.kinesis.putRecords(payload, (error, data) => {
          if (error) {
            return reject(error);
          }

          resolve(data);
        });
      });
    }

    /**
     * @param   {Array} arr
     * @param   {Number} pieces
     *
     * @returns {Array[]}
     *
     * @private
     */

  }, {
    key: '_chunks',
    value: function _chunks(arr, pieces) {
      const len = arr.length;

      let mid = len / pieces;
      let chunks = [];
      let start = 0;

      for (let i = 0; i < pieces; i++) {
        let last = start + mid;

        if (!len % pieces >= i) {
          last = last - 1;
        }

        chunks.push(arr.slice(start, last + 1) || []);

        start = last + 1;
      }

      return chunks;
    }

    /**
     * @see http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/Kinesis.html#putRecord-property
     * 
     * @returns {String}
     */

  }, {
    key: 'kinesis',
    get: function get() {
      return this._kinesis;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'partitionKey',
    get: function get() {
      this._partitionKey = this._partitionKey || _UUID.UUID.generate();

      return this._partitionKey;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'kinesisEventStream',
    get: function get() {
      return this._kinesisEventStream;
    }
  }], [{
    key: 'MAX_PUT_LENGTH',
    get: function get() {
      return 500;
    }
  }]);

  return KinesisDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Driver/KinesisDriver.js
// module id = 385
// module chunks = 0